/* ss-judgeme.js - kjorer overalt der Judge.me-widgeten finnes.
   Laa tidligere inne i sections/ss-reviews-summary.liquid, som bare rendres paa
   produktmaler. Kolleksjonssidene (kalis-collection-reviews.liquid) fikk da CSS-en
   fra theme.liquid men ikke JS-en: gridet sto i auto-fallback uten masonry,
   pilknappen var tom (ikonet skjult av CSS, teksten settes her) og snitt-tallet
   manglet. Lastes naa fra theme.liquid rett etter ss-judgeme.css.
   Seksjonen rendrer bare AI-kortets kilde (#ss-ai-source); dette skriptet finner
   den om den er der. */
(function(){
  var IMG_W = 640;

  /* 1) snitt-tall ved stjernene: 4.96 -> 4.9 (rundes ned, som dummy) */
  function avg(){
    var st = document.querySelector('.jdgm-rev-widg__summary-stars');
    if(!st || st.dataset.ssAvg) return;
    var m = (st.getAttribute('aria-label')||'').match(/([0-9]+[.,][0-9]+)/);
    if(!m) return;
    var s = document.createElement('span');
    s.className = 'ss-jdgm-avg';
    s.textContent = (Math.floor(parseFloat(m[1].replace(',','.'))*10)/10).toFixed(1);
    if(st.parentNode) st.parentNode.insertBefore(s, st.nextSibling); else st.appendChild(s);
    st.dataset.ssAvg = '1';
  }

  /* 2) AI-kortet flyttes inn i widgeten, rett UNDER skriv-knappen.
        Judge.me bygger .jdgm-rev-widg__body helt paa nytt ved paginering,
        og da forsvinner kortet med den gamle DOM-en. Derfor beholdes en
        kopi i ssAiCard, og kortet settes inn paa nytt hver gang det mangler
        - i stedet for aa fjerne kilden som forste versjon gjorde. */
  var ssAiCard = null;
  function moveAi(){
    if(!ssAiCard){
      var src = document.getElementById('ss-ai-source');
      var found = src && src.querySelector('.ss-aisum');
      if(found) ssAiCard = found.cloneNode(true);
    }
    if(!ssAiCard) return;
    if(document.querySelector('.jdgm-rev-widg__moved-ai .ss-aisum')) return;
    /* Kortet legges i HEADER, rett etter stjerner/knapp (.jdgm-row-stars).
       Header overlever sidebytte; body bygges paa nytt av Judge.me, og laa
       kortet der forsvant det under lasting og spinneren krop opp under knappen.
       Fallback til body hvis header mangler. */
    var stars = document.querySelector('.jdgm-rev-widg__header .jdgm-row-stars');
    var head = document.querySelector('.jdgm-rev-widg__header');
    var body = document.querySelector('.jdgm-rev-widg__body');
    if(!head && !body) return;
    var stale = document.querySelector('.jdgm-rev-widg__moved-ai');
    if(stale) stale.remove();
    var wrap = document.createElement('div');
    wrap.className = 'jdgm-rev-widg__moved-ai';
    wrap.appendChild(ssAiCard.cloneNode(true));
    if(stars && stars.parentNode === head) head.insertBefore(wrap, stars.nextSibling);
    else if(head) head.appendChild(wrap);
    else body.insertBefore(wrap, body.firstChild);
  }

  /* 3) bildene: Judge.me laster width=114 og strekker dem. Bytt til 640. */
  function upgradeImgs(){
    /* bare hovedbildet - miniatyrene bilde 2+ vises i 48px og skal ikke
       lastes i 640px. */
    document.querySelectorAll('.jdgm-rev__pics .jdgm-rev__pic-link:first-child .jdgm-rev__pic-img').forEach(function(img){
      if(img.dataset.ssHi) return;
      ['src','data-src'].forEach(function(attr){
        var v = img.getAttribute(attr);
        if(v && /width=\d+/.test(v)) img.setAttribute(attr, v.replace(/width=\d+/, 'width=' + IMG_W));
      });
      if(img.srcset) img.srcset = img.srcset.replace(/width=\d+/g, 'width=' + IMG_W);
      img.dataset.ssHi = '1';
    });
  }

  /* 4) full tekst - ingen "Read more". Guard: Judge.me kan legge klassen tilbake,
        og uten dataset-flagget her ville observeren under gaa i evig loop. */
  /* TO flagg, med vilje:
       data-ss-seen  settes ALLTID, forste gang vi roerer kortet. Uten det
                     ville et kort som fortsatt er avkuttet blitt behandlet paa
                     nytt ved hver observer-kjoring - og siden vi endrer style,
                     trigger vi observeren selv. Evig lokke, siden fryser.
                     Det var nettopp det som brakk pagineringen 09.09.
       data-ss-full  settes bare naar hele teksten faktisk er synlig, og er det
                     CSS-en bruker for aa skjule «Les mer». Et kort vi ikke fikk
                     apnet beholder dermed en fungerende knapp. */
  function untruncate(){
    document.querySelectorAll('.jdgm-rev__body').forEach(function(b){
      if(b.dataset.ssSeen) return;
      b.dataset.ssSeen = '1';
      b.classList.remove('is-truncated');
      b.style.maxHeight = 'none';
      b.style.overflow = 'visible';
      if(b.scrollHeight <= b.clientHeight + 2) b.dataset.ssFull = '1';
    });
  }


  /* 5) tusenskille i antallstekstene. Judge.me skriver raa siffer:
        "(5195 reviews)". Tallene kommer fra deres egne maler
        (widget_summary_text, subtab-etikettene), som ikke har tallformatering,
        og CSS kan ikke omformatere tekst - saa det maa skje her.
        SCOPING ER VIKTIG: bare summary-teksten og subtab-etikettene roeres.
        Tidsstempler ("02/08/2026") har ogsaa 4-sifrede lop og maa ikke treffes,
        derfor gaas det aldri gjennom et helt anmeldelseskort.
        Idempotent: etter gruppering skilles sifrene av et tegn, saa de matcher
        ikke lenger 4+ sammenhengende siffer og en ny kjoring gjor ingenting. */
  var NUM_SEL = '.jdgm-rev-widg__summary-text, .jdgm-all-reviews__summary-text,'
              + ' .jdgm-subtab__name, .jdgm-histogram__percentage';
  var nf;
  try { nf = new Intl.NumberFormat(document.documentElement.lang || 'en'); }
  catch(e) { nf = new Intl.NumberFormat('en'); }
  function numbers(){
    document.querySelectorAll(NUM_SEL).forEach(function(el){
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), node;
      while((node = walker.nextNode())){
        var before = node.nodeValue;
        if(!/\d{4}/.test(before)) continue;
        var after = before.replace(/\d{4,}/g, function(d){ return nf.format(parseInt(d, 10)); });
        if(after !== before) node.nodeValue = after;
      }
    });
  }

  /* 6) paginering som dummyen: «1 2 3 4 … 139 ›». Judge.me rendrer forste og
        siste side som tallose ikonknapper og skjuler ikke vinduet. Vi setter
        tallet fra data-page, legger ellipse mellom vinduet og ytterpunktet, og
        viser ytterpunktet bare naar det ikke alt er i vinduet. Kjorer med
        observeren frakoblet (schedule), saa DOM-endringene her lokker ikke. */
  function paginate(){
    var pag = document.querySelector('.jdgm-paginate'); if(!pag) return;
    var nums = [];
    [].forEach.call(pag.querySelectorAll('.jdgm-paginate__page'), function(p){
      var c = p.className;
      if(/next-page|prev-page|last-page|first-page|ss-ellipsis/.test(c)) return;
      var n = parseInt(p.dataset.page, 10); if(!isNaN(n)) nums.push(n);
    });
    if(!nums.length) return;
    var lo = Math.min.apply(null, nums), hi = Math.max.apply(null, nums);
    [].forEach.call(pag.querySelectorAll('.ss-ellipsis'), function(e){ e.remove(); });
    function ell(cls){ var e = document.createElement('span');
      e.className = 'jdgm-paginate__page ss-ellipsis ' + cls; e.textContent = '\u2026'; return e; }
    var last = pag.querySelector('.jdgm-paginate__last-page');
    if(last){ var L = parseInt(last.dataset.page, 10);
      if(!isNaN(L) && L > hi){ if(last.textContent !== String(L)) last.textContent = String(L);
        last.classList.add('ss-show'); if(L > hi + 1) pag.insertBefore(ell('ss-ell-end'), last); }
      else last.classList.remove('ss-show'); }
    var first = pag.querySelector('.jdgm-paginate__first-page');
    if(first){ var F = parseInt(first.dataset.page, 10);
      if(!isNaN(F) && F < lo){ if(first.textContent !== String(F)) first.textContent = String(F);
        first.classList.add('ss-show'); if(F < lo - 1) pag.insertBefore(ell('ss-ell-start'), first.nextSibling); }
      else first.classList.remove('ss-show'); }
    var nx = pag.querySelector('.jdgm-paginate__next-page'); if(nx && nx.textContent.trim() !== '\u203a') nx.textContent = '\u203a';
    var pv = pag.querySelector('.jdgm-paginate__prev-page'); if(pv && pv.textContent.trim() !== '\u2039') pv.textContent = '\u2039';
  }

  /* 7) masonry: hvert kort faar grid-row: span <hoyde+14>, grid-auto-flow:dense
        legger det i korteste kolonne. Kortene har align-self:start, saa
        gridRowEnd endrer IKKE kortets egen hoyde - ResizeObserveren under
        utloses derfor bare av ekte hoydeendringer (bilder som laster, tekst som
        oversettes, vindu som endrer bredde). Klassen ss-masonry settes forst
        naar minst ett kort er maalt, saa et ikke-maalt grid aldri overlapper. */
  var ro = (typeof ResizeObserver !== 'undefined') ? new ResizeObserver(function(){ schedule(); }) : null;
  function masonry(){
    var g = document.querySelector('.jdgm-rev-widg__reviews'); if(!g) return;
    var cards = g.querySelectorAll('.jdgm-rev'); if(!cards.length) return;
    var any = false;
    cards.forEach(function(c){
      var h = Math.ceil(c.getBoundingClientRect().height);
      if(h > 0){ var span = 'span ' + (h + 14); if(c.style.gridRowEnd !== span) c.style.gridRowEnd = span; any = true; }
      if(ro && !c.dataset.ssRo){ ro.observe(c); c.dataset.ssRo = '1'; }
    });
    if(ro && !g.dataset.ssRo){ ro.observe(g); g.dataset.ssRo = '1'; }
    if(any && !g.classList.contains('ss-masonry')) g.classList.add('ss-masonry');
  }

  /* 8) spraaknavn i oversett-knappen. Judge.me tagger norske anmeldelser 'nb' og rendrer navnet
        klientsiden med Intl.DisplayNames([maalspraak]).of('nb') -> «norskt bokmaal» paa .se, «bokmaal» paa
        .dk, «norsk bokmaal» paa .no (der er maalspraaket nb etter no->nb-mappingen i theme.liquid).
        Bytt til navnet for 'no' («norska», «norsk», ...). Nettleserens egne navn, ingen tabell per spraak.
        Maalspraaket regnes ut med samme uttrykk som widgeten bruker. Idempotent: etter bytte finnes ikke
        bokmaal-strengen lenger i knappen. Kun .jdgm-translate-button roeres. */
  function langNames(){
    var S = window.jdgmSettings || {};
    var target = (S.enable_multi_locales_translations && document.documentElement.lang)
                 || S.shop_locale || S.locale || document.documentElement.lang || 'en';
    var dn; try { dn = new Intl.DisplayNames([target], {type:'language'}); } catch(e){ return; }
    var bad, good; try { bad = dn.of('nb'); good = dn.of('no'); } catch(e){ return; }
    if(!bad || !good || bad === good) return;
    document.querySelectorAll('.jdgm-translate-button').forEach(function(b){
      if(b.textContent.indexOf(bad) !== -1) b.textContent = b.textContent.split(bad).join(good);
    });
  }

  /* 9) summary-teksten skal staa uten parentes paa egen linje («Basert paa 33 anmeldelser»). Teksten
        settes i Judge.me-admin per butikk; dette er sikkerhetsnettet om noen setter «(...)» tilbake.
        Idempotent: etter strippen er det ingen omsluttende parentes aa fjerne. */
  function summaryText(){
    document.querySelectorAll('.jdgm-rev-widg__summary-text').forEach(function(el){
      var t = el.textContent.trim();
      if(t.length > 2 && t.charAt(0) === '(' && t.charAt(t.length - 1) === ')' && el.children.length === 0){
        el.textContent = t.slice(1, -1).trim();
      }
    });
  }

  function run(){ avg(); moveAi(); upgradeImgs(); untruncate(); numbers(); paginate(); masonry(); langNames(); summaryText(); }

  /* debounce, og observeren settes paa pause mens vi selv endrer DOM,
     slik at vaare egne endringer ikke trigger nye kjoringer */
  var timer = null, obs = null, busy = false;
  function schedule(){
    if(busy) return;
    clearTimeout(timer);
    timer = setTimeout(function(){
      busy = true;
      if(obs) obs.disconnect();
      try { run(); } catch(e) {}
      if(obs) obs.observe(document.documentElement, {childList:true, subtree:true});
      busy = false;
    }, 120);
  }
  run();
  obs = new MutationObserver(schedule);
  obs.observe(document.documentElement, {childList:true, subtree:true});
  document.addEventListener('click', function(){ setTimeout(schedule, 400); }, true);
})();
